import Barba_controller from './barba.js';
import SiteVue from './vueCode.js';
import GoogleAnalytics from '../vendor/catapult/googleAnalytics_v2.0.1.js';
import cookie_widget from '../vendor/catapult/cat_cookies_v1.0.1.js';

$(window).on("load", function (e) {
    Site.init();
    $('html').addClass('loaded');
});


const Site = {
    init: function () {
      //    window.base_url     = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

          scroll_class.init(200,500);
          browser_class.init();
          Barba_controller.init();
          Site.cookie();
          SiteVue.initPageVue();
          SiteVue.initMenuVue();
          SiteVue.initFooterVue();
          // $('[data-toggle="tooltip"]').tooltip();
          //    FormValidation.init(document);

      },

      cookie: function () {

        cookie_widget.init({
            'necessary': {'active':true, callback:null, 'default':'true', 'edit':false},
            'social': {'active':false, callback:null, 'default':null, 'edit':true},
            'analytics': {'active':true, callback:GoogleAnalytics.init, 'default':null, 'edit':true},
            'advertising': {'active':false, callback:null, 'default':null, 'edit':true}
        });

      },

      resetScrollPosition: function(){
         $(window).scrollTop(0);
         $("body, html").removeClass("block-scroll");
      },

      scrollBlock: function(active){
        if (active) {
          $("body").addClass("block-scroll");
        }else {
          $("body").removeClass("block-scroll");
        }
      },

      // darkPage: function(){
      //   $("body").removeClass("light");
      //   $("body").addClass("dark");
      // },
      // lightPage: function(){
      //   $("body").removeClass("dark");
      //   $("body").addClass("light");
      // },
};

export default Site;